import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  giftCardId: yup.number().required(),
  expiryDate: yup.string().required(),
  reason: yup.string().required(),
});

export function useUpdateGiftCardExpiryDateMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.put(HTTP_ENDPOINTS.bi.updateGiftCardExpiryDate(), {
        egift_voucher_id: req.giftCardId,
        expiry_date: req.expiryDate,
        reason: req.reason,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.bi.giftCardHistory],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
